import ExcelJS from "exceljs";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        "label": '평가일',
        "value": 'date',
        "query": {'ss': 'startDate', 'ee': 'endDate'},
        "options": {
          default: {sd: '', ed: ''},
        }
      },
      {'component': 'search-disaster-types', "label": '재해형태', "value": 'disaster', "query": {'dty': 'disaster'}, "options": {}},
      {
        'component': 'search-column-keyword',
        "label": '검색조건',
        "value": 'column',
        "query": {'ck_t': 'head', 'ck_k': 'keyword'},
        "options": {hiddenList: ['재해형태', '평가일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  평가일
    if (search.date) {
      conditions.push({key: 'body.inputB_4', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.inputB_4', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({key: 'body.riskAppraisalList[%].input_3', operator: 'LIKE', value: `%${search.disaster}%`})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "작업내용",
        "key": "body.inputB_3"
      },
      {
        "name": "재해형태",
        "key": "body.disasters"
      },
      {
        "name": "평가일",
        "key": "body.inputB_4"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.com_name"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      // disasters 배열 중에서 중복된 항목을 제거한다
      const uniqueDisasters = [...new Set(func.getContent(value).riskAppraisalList.map(item => (item.input_3.indexOf('직접입력_') > -1) ? item.input_3.split('직접입력_')[1] : item.input_3))];
      // 오름차순 정렬
      uniqueDisasters.sort();


      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).inputB_3 // 작업내용
      case 2: return uniqueDisasters.join(', ') // 재해형태
      case 3: return func.getContent(value).inputB_4 // 평가일
      case 4: return func.getContent(value).stdInfo.department // 소속명
      case 5: return func.getContent(value).stdInfo.section // 부서명
      case 6: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
  excelInfo: () => {

    function getResultRisk (data) {
      switch (data) {
      case 'A': return '매우높음'
      case 'B': return '높음'
      case 'C': return '약간높음'
      case 'D': return '보통'
      case 'E': return '낮음'
      case 'F': return '매우낮음'
      }
    }

    return {
      filePath: '/fms/정기위험성평가_행정기관_rev.1.0.xlsx',
      downloadFileName: '정기위험성평가',
      worksheetName: (data) => {
        const body = data.body
        return (body && body.stdInfo && body.stdInfo.field_name) ? body.stdInfo.field_name : '기타';
      },
      applyDataToSheet: async (worksheet, data, func) => {
        const body = data.body
        const merges = func.getMerges();
        let nextRowIndex = 8; // excel 행 번호

        // 기본정보
        func.setMerges(["C1:P5", "F6:F7", "G6:G7", "M6:P6", "O7:P7", "Q6:Q7", "A6:A7", "H6:K6", "L6:L7", "R6:R7", "S6:S7", "J7:K7", "B6:B7", "C6:E6", "F6:F7"])
        worksheet.getCell('B1').value = body.stdInfo.section //업체명
        worksheet.getCell('B2').value = body.stdInfo.field_name //사업장명
        worksheet.getCell('B3').value = body.stdInfo.writer_name //평가자
        worksheet.getCell('B4').value = body.inputB_2 //공종명
        worksheet.getCell('B5').value = body.inputB_3 //작업내용
        worksheet.getCell('R1').value = body.inputB_4 //평가일
        worksheet.getCell('R2').value = body.inputB_8 //실시기간
        worksheet.getCell('S2').value = body.inputB_9 //실시기간

        // 위험성평가표
        const riskAppraisalList = body.riskAppraisalList
        if (riskAppraisalList && riskAppraisalList.length > 0) {
          for (let i = 0; i < riskAppraisalList.length; i++) {
            const risk = riskAppraisalList[i]
            worksheet.insertRow(nextRowIndex, [
              i + 1,
              risk.input_1, //세부작업명
              risk.input_2, //평가구분
              risk.input_4, //유해·위험요인
              risk.유해위험요인설명, //유해·위험요인 설명
              risk.input_3, //재해형태
              risk.input_5, //현재 안전보건조치
              risk.input_6, //현재 위험성 - 가능성
              risk.input_7, //현재 위험성 - 중대성
              risk.input_6 * risk.input_7, //현재 위험성 - 위험도
              getResultRisk(risk.input_8), //현재 위험성 - 위험도
              risk.input_9, //위험성 감소대책
              risk.input_11, //개선후 위험도 - 가능성
              risk.input_12, //개선후 위험도 - 중대성
              risk.input_11 * risk.input_12, //개선후 위험도 - 위험도
              getResultRisk(risk.input_13), //개선후 위험도 - 위험도
              risk.input_14, //개선예정일
              risk.input_15, //완료예정일
              risk.input_16, //담당자
            ])
            worksheet.getRow(nextRowIndex).height = 30
            nextRowIndex++;
          }
        }

        // 안전·보건관리자 검토의견
        const rowIdx = [nextRowIndex + 1, nextRowIndex + 2]
        func.setMerges([
          `H${rowIdx[0]}:K${rowIdx[0]}`,
          `A${rowIdx[0]}:B${rowIdx[1]}`,
          `C${rowIdx[0]}:G${rowIdx[1]}`,
          `M${rowIdx[0]}:S${rowIdx[1]}`,
          `L${rowIdx[0]}:L${rowIdx[1]}`,
          `J${rowIdx[1]}:K${rowIdx[1]}`,
        ])

        nextRowIndex += 3
        if (body.riskAppraisalList2 && body.riskAppraisalList2.length > 0) {
          for (const risk of body.riskAppraisalList2) {
            const row = worksheet.insertRow(nextRowIndex);
            row.getCell(1).value = risk.input1
            row.getCell(3).value = risk.input2
            row.getCell(8).value = risk.input3
            row.getCell(9).value = risk.input4
            row.getCell(10).value = risk.input3 * risk.input4
            row.getCell(11).value = risk.input5
            row.getCell(12).value = risk.input6
            row.getCell(13).value = risk.input7
            row.height = 30
            func.setMerges([
              `A${nextRowIndex}:B${nextRowIndex}`,
              `C${nextRowIndex}:G${nextRowIndex}`,
              `M${nextRowIndex}:S${nextRowIndex}`,
              `L${nextRowIndex}:L${nextRowIndex}`
            ])
            nextRowIndex++;
          }
        }

        // 조치 전/후 사진
        func.setMerges([
          `A${nextRowIndex + 1}:G${nextRowIndex + 1}`,
          `H${nextRowIndex + 1}:S${nextRowIndex + 1}`,
        ])
        nextRowIndex += 2
        for (let _rowIndex = 0;
          (_rowIndex < Math.floor((body.photoList.length + 1) / 2))
              || (_rowIndex < Math.floor((body.photoListAfter.length + 1) / 2));
          _rowIndex++) {
          func.setMerges([
            `A${nextRowIndex}:G${nextRowIndex}`,
            `H${nextRowIndex}:S${nextRowIndex}`,
          ])
          worksheet.getRow(nextRowIndex).height = 286.5

          // 조치 전
          for (let i = 0; i<2; i++) {
            if (body.photoList.length > _rowIndex * 2 + i) {
              const photo = body.photoList[_rowIndex * 2 + i]
              if (photo.id) {
                const paths = photo.path.split("/");
                const hashedName = paths[paths.length - 1];
                await func.addImage(hashedName, {
                  tl: {col: (i === 0 ? 0 : 3) + 0.5, row: nextRowIndex - 1 + 0.01},
                  ext: {width: 500, height: 375},
                })
              }
            }
          }

          // 조치 후
          for (let i = 0; i<2; i++) {
            if (body.photoListAfter.length > _rowIndex * 2 + i) {
              const photo = body.photoListAfter[_rowIndex * 2 + i]
              if (photo.id) {
                const paths = photo.path.split("/");
                const hashedName = paths[paths.length - 1];
                await func.addImage(hashedName, {
                  tl: {col: (i === 0 ? 7 : 12) + 0.5, row: nextRowIndex - 1 + 0.01},
                  ext: {width: 500, height: 375},
                })
              }
            }
          }
          nextRowIndex++;
        }

      }
    }
  }
}
export default list;
